export default [
  {
    path: '/active-xbbj2/index',
    name: 'index',
    component: () => import('@/views/active-xbbj/index'),
    meta: {
      title: '免费领学霸手写笔记—高考直通车独家备考资料'
    }
  },
  {
    path: '/active-xbbj/index',
    name: 'index',
    component: () => import('@/views/active-xbbj/index'),
    meta: {
      title: '免费领学霸手写笔记—高考直通车独家备考资料'
    }
  },
  {
    path: '/active-xbbj/myget',
    name: 'myget',
    component: () => import('@/views/active-xbbj/myget'),
    meta: {
      title: '我的领取'
    }
  },
  {
    path: '/active-xbbj/inviterecord',
    name: 'inviterecord',
    component: () => import('@/views/active-xbbj/inviterecord'),
    meta: {
      title: '邀请记录'
    }
  },
  {
    path: '/active-xbbj/bjdetail/:id',
    name: 'bjdetail',
    component: () => import('@/views/active-xbbj/bjdetail'),
    meta: {
      title: '笔记详情'
    }
  },
  {
    path: '/active-xbbj/bjget/:id',
    name: 'bjget',
    component: () => import('@/views/active-xbbj/bjget'),
    meta: {
      title: '领取笔记'
    }
  },
]
